import PaymentInfoBaseService from './PaymentInfoBaseService'

export default class CreditInfoService extends PaymentInfoBaseService {
  get actionPerformed(): string {
    return ''
  }
}
